import React from "react";

interface TripLoaderProps {
  message?: string;
  showHeader?: boolean;
  showSidePanel?: boolean;
}

const TripLoader: React.FC<TripLoaderProps> = ({
  message = "Loading trip data...",
  showHeader = true,
  showSidePanel = true,
}) => {
  return (
    <section className="bg-white w-full max-h-full flex flex-col items-center overflow-hidden">
      {/* Loading message */}
      <div aria-live="polite" className="sr-only">
        {message}
      </div>

      <div className="w-full max-h-screen flex flex-col items-center justify-center">
        {showHeader && <HeaderSkeleton />}
        <div className="w-full h-screen flex flex-row space-x-4 items-start justify-between my-4">
          {showSidePanel && <SidePanelSkeleton />}
          <MainContentSkeleton />
          <DetailsSkeleton />
        </div>
      </div>
    </section>
  );
};

// Header section skeleton with title, user icons and actions
const HeaderSkeleton: React.FC = () => (
  <div className="flex flex-row items-start justify-between mt-2 mb-4 w-full">
    <div className="flex flex-col w-full space-y-2">
      <div className="top-0 flex flex-row items-center space-x-3 w-full">
        <div
          className="w-[15%] bg-loading rounded-xl h-10 animate-pulse"
          aria-hidden="true"
        />
        <div className="flex flex-row items-center w-full">
          <div
            className="w-10 h-10 bg-loading rounded-full animate-pulse"
            aria-hidden="true"
          />
          <div
            className="w-10 h-10 -ml-4 bg-loading rounded-full animate-pulse"
            aria-hidden="true"
          />
          <div
            className="w-10 h-10 -ml-4 bg-loading rounded-full animate-pulse"
            aria-hidden="true"
          />
          <div className="ml-auto flex space-x-2">
            <div
              className="w-8 h-8 bg-loading rounded-full animate-pulse"
              aria-hidden="true"
            />
            <div
              className="w-8 h-8 bg-loading rounded-full animate-pulse"
              aria-hidden="true"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

// Side navigation panel skeleton
const SidePanelSkeleton: React.FC = () => (
  <div
    className="w-[8%] h-full bg-loading rounded-xl animate-pulse"
    aria-hidden="true"
  />
);

// Main content area skeleton
const MainContentSkeleton: React.FC = () => (
  <div className="w-[45%] h-full flex flex-col space-y-4" aria-hidden="true">
    <div className="w-full h-1/3 bg-loading rounded-xl animate-pulse" />
    <div className="w-full h-2/3 bg-loading rounded-xl animate-pulse" />
  </div>
);

// Right panel details skeleton
const DetailsSkeleton: React.FC = () => (
  <div className="w-[45%] h-full flex flex-col space-y-4" aria-hidden="true">
    <div className="w-full h-1/4 bg-loading rounded-xl animate-pulse" />
    <div className="w-full h-3/4 bg-loading rounded-xl animate-pulse" />
  </div>
);

export default TripLoader;
